import { Outlet } from '@remix-run/react'
import DemoNavigation from '~/components/DemoNavigation'
const navigation = [
	{ name: 'Product', href: '#' },
	{ name: 'Features', href: '#' },
	{ name: 'Marketplace', href: '#' },
	{ name: 'Company', href: '#' },
]

export default function Index() {

	const currentYear = new Date().getFullYear();

	return (
		<div className="bg-white">
			{/* Header */}
			<header className="absolute inset-x-0 top-0 z-50">
				<DemoNavigation />
			</header>

			<main className="">
				<Outlet />
			</main>
			{/* Footer */}
			<footer className="mt-32 sm:mt-32">
				<div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
					<p className="mt-10 text-center text-sm/6 text-gray-600">
						&copy; {currentYear} Binz Binz Binz, Inc. All rights reserved.
					</p>
				</div>
			</footer>
		</div>


	)
}
